import React, { FC } from 'react'

const CurveLine1: FC = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="184"
    height="122"
    viewBox="0 0 184 122"
    fill="none"
  >
    <path
      stroke="#71757D"
      strokeDasharray="14 14"
      strokeLinecap="round"
      strokeOpacity=".5"
      strokeWidth="2"
      d="M1 1.5C49.5 1.5 217.472 22 175.5 121"
    />
  </svg>
)

export default CurveLine1
